type MissingSourceSpec = {
	readonly backgroundMask: boolean;
	readonly colorisation: boolean;
	readonly posterise: boolean;
	readonly enhanceFaces: boolean;
	readonly faceBoundingBoxes: boolean;
};

type GenericPictureConfiguration = {
	readonly removeBackground?: object | null;
	readonly fixFaceColours?: boolean;
	readonly enhanceFaces?: boolean;
	readonly posterise?: boolean;
};

function getMissingBuildSources(
	{
		removeBackground,
		fixFaceColours,
		enhanceFaces,
		posterise,
	}: GenericPictureConfiguration,
	availableSources: MissingSourceSpec,
): MissingSourceSpec {
	return {
		backgroundMask:
			(!!fixFaceColours || !!removeBackground) &&
			!availableSources.backgroundMask,
		colorisation: !!fixFaceColours && !availableSources.colorisation,
		faceBoundingBoxes: !!fixFaceColours && !availableSources.faceBoundingBoxes,
		enhanceFaces: !!enhanceFaces && !availableSources.enhanceFaces,
		posterise: !!posterise && !availableSources.posterise,
	};
}

export type { MissingSourceSpec };
export default getMissingBuildSources;
